var _desc, _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorInstaBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.48 51L14.51 51C6.52 51 0 44.5 0 36.48L0 14.51C0 6.52 6.52 0 14.51 0L36.48 0C44.5 0 51 6.52 51 14.51L51 36.48C51 44.5 44.5 51 36.48 51ZM14.51 4.36C8.91 4.36 4.36 8.91 4.36 14.51L4.36 36.48C4.36 42.08 8.91 46.63 14.51 46.63L36.48 46.63C42.08 46.63 46.63 42.08 46.63 36.48L46.63 14.51C46.63 8.91 42.08 4.36 36.48 4.36L14.51 4.36Z",
    fill: "#000000",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.5 38.55C18.29 38.55 12.44 32.7 12.44 25.5C12.44 18.29 18.29 12.44 25.5 12.44C32.7 12.44 38.55 18.29 38.55 25.5C38.55 32.7 32.7 38.55 25.5 38.55ZM25.5 16.8C20.71 16.8 16.8 20.71 16.8 25.5C16.8 30.28 20.71 34.19 25.5 34.19C30.28 34.19 34.19 30.28 34.19 25.5C34.19 20.71 30.28 16.8 25.5 16.8Z",
    fill: "#000000",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.27 11.69C42.27 13.44 40.88 14.83 39.13 14.83C37.39 14.83 36 13.44 36 11.69C36 9.95 37.39 8.56 39.13 8.56C40.85 8.56 42.27 9.95 42.27 11.69Z",
    fill: "#000000",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorInstaBlack);
export default __webpack_public_path__ + "static/media/Vector-Insta-Black.25e2e83907869b8aa74802a553fb1eaf.svg";
export { ForwardRef as ReactComponent };